import { useCallback } from 'react';
import { useShittyMapStore } from '@/hooks/useShittyMapStore';

export function useShittyMapCamera() {
  const { setFocusTarget, cameraPosition } = useShittyMapStore();

  const animateTo = useCallback(
    (x, y, zoom, duration = 1000) => {
      setFocusTarget({ x, y, zoom, duration });
    },
    [setFocusTarget]
  );

  const focusOnCity = useCallback(
    (x, y) => {
      animateTo(x, y, 2, 800);
    },
    [animateTo]
  );

  const showAllCities = useCallback(() => {
    animateTo(0, 0, 0.8, 1000);
  }, [animateTo]);

  const flyToMultiple = useCallback(
    (positions, padding = 200) => {
      if (!positions || positions.length === 0) {
        showAllCities();
        return;
      }

      if (positions.length === 1) {
        focusOnCity(positions[0].x, positions[0].y);
        return;
      }

      const bounds = positions.reduce(
        (acc, pos) => ({
          minX: Math.min(acc.minX, pos.x),
          maxX: Math.max(acc.maxX, pos.x),
          minY: Math.min(acc.minY, pos.y),
          maxY: Math.max(acc.maxY, pos.y),
        }),
        { minX: Infinity, maxX: -Infinity, minY: Infinity, maxY: -Infinity }
      );

      const centerX = (bounds.minX + bounds.maxX) / 2;
      const centerY = (bounds.minY + bounds.maxY) / 2;

      const width = bounds.maxX - bounds.minX + padding * 2;
      const height = bounds.maxY - bounds.minY + padding * 2;

      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight - 200;

      const zoomX = viewportWidth / width;
      const zoomY = viewportHeight / height;
      const targetZoom = Math.min(zoomX, zoomY, 2);

      animateTo(centerX, centerY, Math.max(targetZoom * 0.8, 0.2), 1200);
    },
    [animateTo, showAllCities, focusOnCity]
  );

  return {
    animateTo,
    focusOnCity,
    showAllCities,
    flyToMultiple,
    currentPosition: cameraPosition,
  };
}
